// extracted by mini-css-extract-plugin
export default {"reminder_styles":"reminder_reminder_styles__inIGg","inline":"reminder_inline__JJyEO","width-50":"reminder_width-50__EA-Gc","fixtop":"reminder_fixtop__IH0t2"};